import { call, put, takeLatest } from 'redux-saga/effects';
import PayoutActions from '../actions/PayoutActions';
import PayoutApi from '../apis/PayoutApi';

function* save(action) {
    try {
        yield put(PayoutActions.showLoading());
        const { model, history } = action.payload;
        const res = yield call(PayoutApi.save, model);
        yield put(PayoutActions.hideLoading());
        yield put(PayoutActions.saveSuccess({ ...res }));
        history.push('/competitive/success');
    } catch (e) {
        yield put(PayoutActions.hideLoading());
        yield put(PayoutActions.showError(e));
        console.info('Failed to save account: ', e);
    }
}

function* savePayoutInfo(action) {
    try {
        yield put(PayoutActions.showLoading());
        const { model } = action.payload;
        const res = yield call(PayoutApi.save, model);
        yield put(PayoutActions.hideLoading());
        yield put(PayoutActions.savePayoutInfoSuccess({...res}));
    } catch (e) {
        yield put(PayoutActions.savePayoutInfoFailed({}));
        yield put(PayoutActions.hideLoading());
        yield put(PayoutActions.showError(e));
    }
}

function* get() {
    try {
        yield put(PayoutActions.showLoading());
        const res = yield call(PayoutApi.get);
        yield put(PayoutActions.hideLoading());
        const { payoutRes, taxinfoRes } = res;
        if (payoutRes) {
            yield put(PayoutActions.getSuccess({ ...payoutRes }));
        }
        if (taxinfoRes) {
            taxinfoRes.foreignTax = taxinfoRes.address.country !== 'US';
            taxinfoRes.taxId = taxinfoRes.status === 'ACTIVE' ? '*********' : '';
            yield put(PayoutActions.getSuccess({ ...taxinfoRes }));
        }
    } catch (e) {
        yield put(PayoutActions.hideLoading());
        console.info('Failed to get account: ', e);
    }
}

function setForm(action) {
    put(PayoutActions.setForm(action.payload));
}

function* PayoutSaga() {
    yield takeLatest(PayoutActions.TYPES.PAYOUT_SAVE, save);
    yield takeLatest(PayoutActions.TYPES.PAYOUT_GET, get);
    yield takeLatest(PayoutActions.TYPES.PAYOUT_SET_FORM, setForm);
    yield takeLatest(PayoutActions.TYPES.PAYOUT_SAVE_INFO, savePayoutInfo);
}

export default PayoutSaga;
